import aemClientService from '@/services/aem/aemClientService';
import type {MarketContentModel} from '@/types/aem';

let content: MarketContentModel = {};

export const initContent = async (marketName: string, languageCode: string) => {
    content = await aemClientService.initMarketContent<MarketContentModel>(
        marketName?.toLowerCase(),
        languageCode?.toLowerCase()
    );
};

export const getContent = (): MarketContentModel => content;
